import { englishBeside } from '@shared/ptEn';

/** Portuguese on the first line, English in a smaller line under it. */
export function Bilingual({ text, english }: { text: string; english?: string }) {
  const gloss = english?.trim() || englishBeside(text);
  if (!gloss) return text;
  return (
    <span className="bilingual">
      <span className="bilingual__pt">{text}</span>
      <span className="bilingual__en">{gloss}</span>
    </span>
  );
}
